const mod = crateImports["@xing-com/crate-communication-in-view"];
const { InViewTracking,Observed,Observer,ObserverContext } = mod;
export { InViewTracking,Observed,Observer,ObserverContext };
export default mod.default ?? mod;